import PubSubFactory from "pubsub/PubSubFactory";

export function* initPubsub() {
  yield PubSubFactory.initFromDB();
}

export function* destroyLogoutBranchThread() {
  yield PubSubFactory.destroyLogoutBranchThread();
}

export function* startCheckingNews(action) {
  const { prefixKey, domain } = action;

  if (prefixKey) yield PubSubFactory.getEvent(prefixKey, domain).startCheckingNews();
  else console.error("startCheckingNews - prefixKey is not defined");
}

export function* destroyBranchThread(action) {
  const { prefixKey } = action;

  if (prefixKey) yield PubSubFactory.destroyBranchThread(prefixKey);
  else console.error("destroyBranchThread - prefixKey is not defined");
}
